/*eslint quote-props: off*/
const tr = {
  language:{
    ptBR:         'Português',
    en:           'Inglês',
    es:           'Espanhol',
    placeholder:  'Selecione uma linguagem',
    'pt-BR':      'Português',
  },
  currency:{
    brl:          'Reais',
    usd:          'Dólares',
    eur:          'Euros',
    ars:          'Peso Argentino',
    placeholder:  'Selecione uma moeda',
  },
  list_currency:{
    R$:           'Reais',
    US$:          'Dólares',
  },
  card_type:{
    img_left:     'Imagem à esquerda',
    img_right:    'Imagem à direita',
    img_bg:       'Somente Texto',
    img_head:     'Imagem acima',
    placeholder:  'Selectione um tipo de card',
  }
};

export default tr;
